// extracted by mini-css-extract-plugin
export default {"page-max-width":"1020px","pageMaxWidth":"1020px","medium":"only screen and (min-width: 768px)","title":"_2QjYy","container":"_2dLmv","content":"_17T5H","productDescription":"_3Nvv6"};